export const maquetaTpl = {
  modalDatos: {
    regTitle: `Información del registro`,
    paymentMethod: `Método de pago`,
    paymentDate: `Fecha de pago`,
    guestCount: `Cantidad de huéspedes`,
    unspecified: `Sin especificar`,
    pay: {
      DESTI: `Pago en destino`,
      EFECT: `Efectivo`,
      MOVIL: `Pago por móvil`,
      OTRO: `Otros medios de pago`,
      PLATF: `Plataforma de pago`,
      TARJT: `Tarjeta de crédito`,
      TRANS: `Transferencia`,
      TREG: `Tarjeta regalo`,
    },
  },
  whatsapp: {
    title: `Acceso exclusivo a WhatsApp Business`,
    body: `Para acceder a la función de WhatsApp Business, se requiere una suscripción activa a WhatsApp Business Personal. Esta opción está diseñada para ofrecerte herramientas adicionales y funciones avanzadas para potenciar tu experiencia comercial.`,
  },
  nav: {
    welcome: `Bienvenido`,
    manager: `Manager`,
    logout: `Cerrar sesión`,
    logoutError: `Sorry, an error occurred when logging out`,
  },
  subnav: {
    home: `Inicio`,
    clients: `Clientes`,
    prices: `Precios`,
    payments: `Pagos`,
    userManagement: `Gestion de usuarios`,
  },
};
